// HÜRS — Cellular Frost product page interactions
(function () {
  function init(root) {
    root = root || document;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    var revealEls = root.querySelectorAll('.hurs-reveal');
    function fillStats(el) {
      el.querySelectorAll('.hurs-stat-fill').forEach(function (fill) {
        fill.style.width = fill.dataset.value + '%';
      });
    }
    if (inEditor) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
        fillStats(el);
      });
    } else if ('IntersectionObserver' in window && revealEls.length) {
      // rootMargin extends the trigger zone 300px below the actual viewport,
      // so the reveal fires while the block is still below the fold and has
      // finished animating in by the time it's scrolled into view — instead
      // of only starting once the block is already 20% on-screen, which on
      // a normal scroll speed reads as a blank flash before it "loads in".
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              fillStats(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px 300px 0px' }
      );
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
        fillStats(el);
      });
    }

    root.querySelectorAll('[data-hurs-qty]').forEach(function (stepper) {
      var valueEl = stepper.querySelector('.hurs-qty-value');
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      var realInput = stepper.parentElement ? stepper.parentElement.querySelector('[data-hurs-qty-real]') : null;
      var qty = 1;
      function render() {
        valueEl.textContent = qty;
        if (realInput) realInput.value = qty;
        stepper.dispatchEvent(new CustomEvent('qtychange', { detail: qty, bubbles: true }));
      }
      minus.addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); });
      plus.addEventListener('click', function () { qty = qty + 1; render(); });
    });

    var options = root.querySelectorAll('[data-hurs-buy-option]');
    var priceOut = root.querySelector('[data-hurs-total-price]');
    var sellingPlanInput = root.querySelector('[data-hurs-selling-plan-input]');
    function selectOption(target) {
      options.forEach(function (el) { el.classList.toggle('is-selected', el === target); });
      if (priceOut) priceOut.textContent = target.dataset.price;
      if (sellingPlanInput) {
        if (target.dataset.sellingPlanId) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = target.dataset.sellingPlanId;
        } else {
          sellingPlanInput.disabled = true;
        }
      }
    }
    options.forEach(function (el) {
      el.addEventListener('click', function () { selectOption(el); });
    });

    root.querySelectorAll('[data-hurs-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var gallery = btn.closest('.hurs-pdp-gallery');
        var mainImg = gallery ? gallery.querySelector('[data-main-image] img') : null;
        if (mainImg) {
          // The main image renders with a srcset/sizes pair for responsive
          // loading. Browsers pick the displayed image from srcset whenever
          // it's present and ignore a plain `src` change, so setting src
          // alone silently did nothing — the click "worked" but the image
          // never visibly swapped. Clearing srcset/sizes makes src win.
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = btn.dataset.full;
        }
        if (btn.parentElement) {
          btn.parentElement.querySelectorAll('[data-hurs-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        }
        btn.classList.add('is-active');
      });
    });

    root.querySelectorAll('[data-hurs-ba]').forEach(function (ba) {
      var after = ba.querySelector('.hurs-ba__after');
      var handle = ba.querySelector('.hurs-ba__handle');
      var dragging = false;
      function setPosition(clientX) {
        var rect = ba.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }
      handle.addEventListener('pointerdown', function (e) { dragging = true; e.preventDefault(); });
      window.addEventListener('pointerup', function () { dragging = false; });
      window.addEventListener('pointermove', function (e) { if (dragging) setPosition(e.clientX); });
      ba.addEventListener('click', function (e) { setPosition(e.clientX); });
    });

    root.querySelectorAll('[data-hurs-review-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.parentElement.querySelectorAll('[data-hurs-review-filter]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

  }

  if (!window.__hursPdpInit) {
    window.__hursPdpInit = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
